import * as React from 'react';
import { TileLayer } from 'react-leaflet';
import { getTileLayerUrl } from './get-tile-layer-url';
export function BuildingHighlightLayer({ selectedBuildingId, baseTileset }) {
    return React.createElement(TileLayer, { key: `${selectedBuildingId}-${baseTileset}`, url: getTileLayerUrl('highlight', { highlight: `${selectedBuildingId}`, base: baseTileset }), minZoom: 13, maxZoom: 19, detectRetina: false });
}
